/**
 * QEVIQ mobile gallery progress marks — syncs with Dawn slider-component slideChanged.
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function setMobileControlAccess(gallery, isMobile) {
    const arrows = gallery.querySelectorAll('.qeviq-product-gallery__arrows .slider-button');
    arrows.forEach((button) => {
      if (isMobile) {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-hidden', 'true');
      } else {
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-hidden');
      }
    });

    const zoomToggles = gallery.querySelectorAll(
      '.qeviq-product-gallery .product__modal-opener--image .product__media-toggle'
    );
    zoomToggles.forEach((button) => {
      if (isMobile) {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-hidden', 'true');
      } else {
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-hidden');
      }
    });
  }

  function initProgress(progress) {
    if (progress.dataset.qeviqProgressReady === 'true') return;

    const gallery = progress.closest('media-gallery');
    if (!gallery) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    const marks = Array.from(progress.querySelectorAll('.qeviq-gallery-progress__mark'));
    if (!marks.length) return;

    const getSlides = () =>
      Array.from(viewer.querySelectorAll('.product__media-item')).filter((slide) => {
        return slide.clientWidth > 0 && !slide.hasAttribute('hidden');
      });

    const setActive = (index) => {
      marks.forEach((mark, i) => {
        const active = i === index;
        mark.classList.toggle('is-active', active);
        if (active) {
          mark.setAttribute('aria-current', 'true');
        } else {
          mark.removeAttribute('aria-current');
        }
      });
    };

    const syncFromViewer = (detail) => {
      if (detail && typeof detail.currentPage === 'number') {
        setActive(Math.max(0, detail.currentPage - 1));
        return;
      }

      const slides = getSlides();
      const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (active >= 0) {
        setActive(active);
        return;
      }

      if (viewer.currentPage) {
        setActive(Math.max(0, viewer.currentPage - 1));
      }
    };

    viewer.addEventListener('slideChanged', (event) => {
      syncFromViewer(event.detail);
    });

    marks.forEach((mark) => {
      mark.addEventListener('click', () => {
        const index = Number(mark.dataset.index);
        if (Number.isNaN(index)) return;

        const slides = getSlides();
        const target = slides[index];
        if (!target || !viewer.slider) return;

        if (typeof viewer.setSlidePosition === 'function') {
          viewer.setSlidePosition(target.offsetLeft);
        } else {
          viewer.slider.scrollTo({ left: target.offsetLeft });
        }
        setActive(index);
      });
    });

    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (thumbnails) {
      thumbnails.addEventListener('click', () => {
        window.requestAnimationFrame(() => syncFromViewer());
      });
    }

    const applyAccess = () => setMobileControlAccess(gallery, MOBILE_MQ.matches);
    applyAccess();
    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', applyAccess);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(applyAccess);
    }

    syncFromViewer();
    progress.dataset.qeviqProgressReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-qeviq-gallery-progress]').forEach(initProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
